import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

// Components
import { InputNumber } from 'antd';

// Helpers
import _noop from 'lodash/noop';
import _isEmpty from 'lodash/isEmpty';
import Content from '../../atoms/Content';
import { disableKeyUpDownInInputNumber } from './numberInput.helpers';
import s from './numberInput.module.scss';
var DEFAULT_PARSER = function DEFAULT_PARSER(value) {
  return value;
};
var NumberInput = /*#__PURE__*/function (_PureComponent) {
  _inherits(NumberInput, _PureComponent);
  var _super = _createSuper(NumberInput);
  function NumberInput(props) {
    var _this;
    _classCallCheck(this, NumberInput);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "resetValue", function () {
      var value = _this.props.value;
      _this.setState({
        lastValue: value
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleOnFocus", function (evt) {
      var onFocus = _this.props.onFocus;
      onFocus(evt);
      _this.setState({
        isFocused: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleOnBlur", function () {
      var _this$props = _this.props,
        onBlur = _this$props.onBlur,
        triggerChangeOnBlur = _this$props.triggerChangeOnBlur,
        onChange = _this$props.onChange;
      var lastValue = _this.state.lastValue;
      if (triggerChangeOnBlur) {
        onChange(lastValue);
      }
      onBlur();
      _this.setState({
        isFocused: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value) {
      var _this$props2 = _this.props,
        onChange = _this$props2.onChange,
        triggerChangeOnBlur = _this$props2.triggerChangeOnBlur;
      if (triggerChangeOnBlur) {
        _this.setState({
          lastValue: value
        });
        return;
      }
      onChange(value);
    });
    _defineProperty(_assertThisInitialized(_this), "renderAddOns", function (content, className) {
      var _this$props3 = _this.props,
        disabled = _this$props3.disabled,
        addOnAfterClassName = _this$props3.addOnAfterClassName;
      if (!content) return null;
      return /*#__PURE__*/React.createElement(Content, {
        className: cx(className, addOnAfterClassName, _defineProperty({}, s.disabled, disabled))
      }, content);
    });
    _this.state = {
      isFocused: false,
      lastValue: props.value
    };
    _this.ref = !_isEmpty(props.innerRef) ? props.innerRef : /*#__PURE__*/React.createRef();
    return _this;
  }
  _createClass(NumberInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$ref, _this$ref$current;
      var shouldDisableKeyHandlerForStepper = this.props.shouldDisableKeyHandlerForStepper;
      if (shouldDisableKeyHandlerForStepper && (_this$ref = this.ref) !== null && _this$ref !== void 0 && (_this$ref$current = _this$ref.current) !== null && _this$ref$current !== void 0 && _this$ref$current.inputNumberRef) {
        var inputNumberRef = this.ref.current.inputNumberRef;
        disableKeyUpDownInInputNumber(inputNumberRef);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props4 = this.props,
        value = _this$props4.value,
        triggerChangeOnBlur = _this$props4.triggerChangeOnBlur;
      if (prevProps.value !== value && triggerChangeOnBlur) {
        this.resetValue();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _cx2, _cx3;
      var _this$props5 = this.props,
        className = _this$props5.className,
        defaultValue = _this$props5.defaultValue,
        disabled = _this$props5.disabled,
        error = _this$props5.error,
        warning = _this$props5.warning,
        max = _this$props5.max,
        min = _this$props5.min,
        placeholder = _this$props5.placeholder,
        precision = _this$props5.precision,
        id = _this$props5.id,
        addonBefore = _this$props5.addonBefore,
        addonAfter = _this$props5.addonAfter,
        value = _this$props5.value,
        triggerChangeOnBlur = _this$props5.triggerChangeOnBlur,
        shouldDisabledStepper = _this$props5.shouldDisabledStepper,
        parser = _this$props5.parser,
        onPressEnter = _this$props5.onPressEnter,
        formatter = _this$props5.formatter,
        step = _this$props5.step,
        isRightAlign = _this$props5.isRightAlign,
        autoFocus = _this$props5.autoFocus,
        onKeyDown = _this$props5.onKeyDown,
        dataTest = _this$props5.dataTest,
        wrapperDivProps = _this$props5.wrapperDivProps;
      var _this$state = this.state,
        isFocused = _this$state.isFocused,
        lastValue = _this$state.lastValue;
      var inputClassName = cx(className, s.numberInputField, (_cx2 = {}, _defineProperty(_cx2, s.inputError, error), _defineProperty(_cx2, s.inputWarning, warning), _defineProperty(_cx2, s.disabled, disabled), _defineProperty(_cx2, s.hasFocus, isFocused), _cx2));
      return /*#__PURE__*/React.createElement("div", _extends({
        className: inputClassName
      }, wrapperDivProps), this.renderAddOns(addonBefore, s.addOnBefore), /*#__PURE__*/React.createElement(InputNumber, {
        id: id,
        className: cx(s.numberInput, (_cx3 = {}, _defineProperty(_cx3, s.disabledStepper, shouldDisabledStepper), _defineProperty(_cx3, s.rightAlignContent, isRightAlign), _cx3)),
        defaultValue: defaultValue,
        disabled: disabled,
        max: max,
        min: min,
        onBlur: this.handleOnBlur,
        onChange: this.handleChange,
        onFocus: this.handleOnFocus,
        placeholder: placeholder,
        precision: precision,
        value: triggerChangeOnBlur ? lastValue : value,
        parser: parser,
        formatter: formatter,
        onPressEnter: onPressEnter,
        onKeyDown: onKeyDown,
        step: step,
        autoFocus: autoFocus,
        ref: this.ref,
        "data-test": dataTest
      }), this.renderAddOns(addonAfter, s.addOnAfter));
    }
  }]);
  return NumberInput;
}(PureComponent);
NumberInput.propTypes = {
  className: PropTypes.string,
  defaultValue: PropTypes.number,
  disabled: PropTypes.bool,
  max: PropTypes.number,
  min: PropTypes.number,
  onChange: PropTypes.func,
  value: PropTypes.number,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  error: PropTypes.string,
  precision: PropTypes.number,
  triggerChangeOnBlur: PropTypes.bool,
  shouldDisabledStepper: PropTypes.bool,
  parser: PropTypes.func,
  step: PropTypes.number,
  isRightAlign: PropTypes.bool,
  onPressEnter: PropTypes.func,
  onKeyDown: PropTypes.func,
  innerRef: PropTypes.object,
  shouldDisableKeyHandlerForStepper: PropTypes.bool,
  // Up and Down arrow keys wont change the number in the input
  dataTest: PropTypes.string,
  wrapperDivProps: PropTypes.object,
  addOnAfterClassName: PropTypes.string
};
NumberInput.defaultProps = {
  className: '',
  defaultValue: '',
  value: '',
  disabled: false,
  max: Infinity,
  min: -Infinity,
  onChange: _noop,
  onFocus: _noop,
  onBlur: _noop,
  onPressEnter: _noop,
  shouldDisabledStepper: false,
  error: null,
  precision: undefined,
  triggerChangeOnBlur: false,
  parser: DEFAULT_PARSER,
  step: 1,
  isRightAlign: false,
  onKeyDown: _noop,
  innerRef: undefined,
  shouldDisableKeyHandlerForStepper: false,
  dataTest: undefined,
  wrapperDivProps: null,
  addOnAfterClassName: ''
};
export default NumberInput;